import React from 'react'

const About = () => {
    return (
        <>
            <h1>A propos de cette App</h1>
            <p>Cette App permet de rechercher des utilisateurs Github</p>
            <p>Version : 1.0.0</p>
        </>
    )
}

export default About
